export default __webpack_public_path__ + "static/media/i_cultural_l.642bfcfe.png";